import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/home.js';
import Page404 from './pages/page-404.js';
import VerifyEmail from './pages/verify-email.js';
import Brands from './pages/brands.js';
import Portfolio from './components/brands/Generate';
import BrandShow from './components/brands/BrandShow';
import SignIn from './pages/sign-in.js';
import { Helmet } from 'react-helmet';
import Lines from './components/common/Lines';
import ProgressScroll from './components/common/ProgressScroll';
import Cursor from './components/common/cusor';
import LoadingScreen from './components/common/loader';
import Navbar from './components/common/Navbar';
import { ToastProvider } from './contexts/ToastContext';
import SurveyScreen from './pages/survey.js';
import AuthWrapper from './components/common/AuthWrapper';

// Wrapper component for Portfolio
function PortfolioWrapper() {
  return (
    <>
      <Helmet>
        <title>Create New Brand - NarrativeOS</title>
        <link rel="icon" href="/assets/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/assets/imgs/favicon.ico" />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap"
        />
      </Helmet>
      <LoadingScreen />
      <Cursor />
      <ProgressScroll />
      <Lines />
      <Navbar />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <main className="main-bg o-hidden">
            <Portfolio />
          </main>
        </div>
      </div>
    </>
  );
}

function App() {
  return (
    <ToastProvider>
      <Router>
        <AuthWrapper>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/brands/new" element={<PortfolioWrapper />} />
            <Route path="/brands/:projectId" element={<BrandShow />} />
            <Route path="/survey" element={<SurveyScreen />} />
            <Route path="/page-404" element={<Page404 />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="*" element={<Page404 />} />
          </Routes>
        </AuthWrapper>
      </Router>
    </ToastProvider>
  );
}

export default App;
